module.exports = __webpack_public_path__ + "assets/pin-completed.cad4831b.svg";